import * as React from "react";
import { forwardRef } from "react";
const SvgFilledInfo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", fill: "#0073E6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.00004 13.6667C3.31804 13.6667 0.333374 10.682 0.333374 7.00004C0.333374 3.31804 3.31804 0.333374 7.00004 0.333374C10.682 0.333374 13.6667 3.31804 13.6667 7.00004C13.6667 10.682 10.682 13.6667 7.00004 13.6667ZM6.33337 6.33337V10.3334H7.66671V6.33337H6.33337ZM6.33337 3.66671V5.00004H7.66671V3.66671H6.33337Z" }));
const ForwardRef = forwardRef(SvgFilledInfo);
export { ForwardRef as ReactComponent };
